import * as React from 'react';
import IconButton, { IconButtonContext, IconButtonType } from './IconButton';

const sectionStyle: React.CSSProperties = { marginBottom: '40px' };
const rowStyle: React.CSSProperties = {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  flexWrap: 'wrap',
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section style={sectionStyle}>
    <h2>{title}</h2>
    <div style={rowStyle}>{children}</div>
  </section>
);

const CONTEXTS: IconButtonContext[] = ['talent', 'company', 'neutral', 'semantic'];
const TYPES: IconButtonType[] = ['primary', 'secondary', 'terceary'];

const IconButtonExamples: React.FC = () => {
  const handleClick = () => alert('IconButton clicked');

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>IconButton Component Examples</h1>

      <Section title="All combinations (context × type)">
        {CONTEXTS.map((context) =>
          TYPES.map((type) => (
            <IconButton
              key={`${context}-${type}`}
              iconName="x"
              aria-label={`${context} ${type}`}
              context={context}
              type={type}
              onClick={handleClick}
            />
          ))
        )}
      </Section>

      <Section title="Sizes">
        <IconButton iconName="x" aria-label="Small" size="S" onClick={handleClick} />
        <IconButton iconName="x" aria-label="Medium" size="M" onClick={handleClick} />
      </Section>

      <Section title="Disabled by type">
        <IconButton iconName="x" aria-label="Disabled primary" disabled onClick={handleClick} />
        <IconButton
          iconName="x"
          aria-label="Disabled secondary"
          type="secondary"
          disabled
          onClick={handleClick}
        />
        <IconButton
          iconName="x"
          aria-label="Disabled terceary"
          type="terceary"
          disabled
          onClick={handleClick}
        />
      </Section>

      <Section title="As links">
        <IconButton iconName="link" aria-label="Profile" href="/profile" />
        <IconButton iconName="link" aria-label="Jobs" href="/jobs" type="secondary" />
        <IconButton
          iconName="link"
          aria-label="External"
          href="https://example.com"
          target="_blank"
        />
        <IconButton iconName="link" aria-label="Disabled link" href="/page" disabled />
      </Section>

      <Section title="Real-world">
        <IconButton iconName="x" aria-label="Close dialog" type="terceary" onClick={handleClick} />
        <IconButton
          iconName="trash"
          aria-label="Delete"
          context="semantic"
          type="terceary"
          onClick={handleClick}
        />
        <IconButton
          iconName="check"
          aria-label="Confirm"
          context="talent"
          type="primary"
          onClick={handleClick}
        />
      </Section>
    </div>
  );
};

export default IconButtonExamples;
